import { Component, OnInit } from '@angular/core';
import { Member } from '../../../../models/member.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberService } from '../../../../services/member/member.service';
import { GeneralService } from '../../../../services/general/general.service';
import { ConceptValues } from '../../../../models/concept-values.model';
import { FormGroup } from '@angular/forms';
import { Concept } from '../../../../models/concept.model';

@Component({
  selector: 'app-minister-postulation',
  templateUrl: './minister-postulation.component.html',
  styleUrls: ['./minister-postulation.component.scss']
})

/* 
--------------------------------------------------------------------------------------
  ESTE COMPONENTE NO ESTA SIENDO UTILIZADO, USAR COMPONENTE PostulateMinisterComponent
--------------------------------------------------------------------------------------
*/
export class MinisterPostulationComponent implements OnInit {
  panelOpenState = false;
  member: Member;

  registerForm: FormGroup;
  showSecondForm: boolean = false;
  loader: any;

  academicLevels: ConceptValues;
  ministerAcademicLevel: ConceptValues;

  constructor(private _activatedRoute: ActivatedRoute,
    private memberService: MemberService,
    private generalService: GeneralService,
    private router: Router) { }

  ngOnInit() {

    this._activatedRoute.params.subscribe((parameters: Member) => {
      let memberId = parameters.id;
      this.member = this.generalService.members[memberId];
      if (this.member == null) {
        this.memberService.getMembers().subscribe(
          (data: Member[]) => {
            data.forEach(member => {
              this.generalService.members[member.id] = member;
              if (memberId == member.id) {
                this.member = this.generalService.members[member.id];
              }
            });
            console.log('member data ', this.member);
          },
          (error) => {
            console.log('error', error)
            this.router.navigate(['/admin', 'members']);
          });
        console.log('member data ', this.member);
      }
    });

    this.academicLevels = this.generalService.concepts[11];
    if (this.academicLevels == null) {
      this.generalService.getConceptDataById(11).subscribe(
        (data: Concept) => {
          this.academicLevels = data.values;
          console.log('concept 11 data ', this.academicLevels);
        },
        (error) => {
          console.log('error', error)
          this.router.navigate(['/admin', 'members']);
        });
      console.log('academicLevels', this.academicLevels);
    }

    this.ministerAcademicLevel = this.generalService.concepts[12];
    if (this.ministerAcademicLevel == null) {
      this.generalService.getConceptDataById(12).subscribe(
        (data: Concept) => {
          this.ministerAcademicLevel = data.values;
          console.log('concept 12 data ', this.ministerAcademicLevel);
        },
        (error) => {
          console.log('error', error)
          this.router.navigate(['/admin', 'members']);
        });
      console.log('ministerAcademicLevel', this.ministerAcademicLevel);
    }
  }

  selectAcademicLevel(level) {
    console.log('selectAcademicLevel', level);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/ministers/minister-postulation/minister-postulation.component.ts